import { object, string, pipe, check, array, minLength } from 'valibot'

import { ERROR_MESSAGES } from '@/constants/common/message.constants'
/**
 * ファイルアップロード（複数）のスキーマ
 */
export const uploadFilesSchema = object({
  key: pipe(string(), minLength(1, ERROR_MESSAGES.UPLOAD_FILE_CORRECTLY)),
  name: pipe(string(), minLength(1, ERROR_MESSAGES.UPLOAD_FILE_CORRECTLY))
})

/**
 * 必須項目のファイルアップロード（複数）のスキーマ
 */
export const requireUploadFilesSchema = pipe(
  array(uploadFilesSchema),
  check(
    (files) =>
      files.length > 0 &&
      files.every(
        (file) => file !== null && file.key.length > 0 && file.name.length > 0
      ),
    ERROR_MESSAGES.UPLOAD_FILE_CORRECTLY
  )
)
